import { combineReducers } from 'redux'
import { Map } from 'immutable'
import { SALE_BALANCES_FETCHED, RESERVED_AD_FEES_FETCHED, TOTAL_BALANCE_FETCHED } from './actions'

const saleBalances = (state = Map(), action) => {
  switch (action.type) {
    case SALE_BALANCES_FETCHED:
      return action.saleBalances
    default:
      return state
  }
}

const reservedAdFees = (state = Map(), action) => {
  switch (action.type) {
    case RESERVED_AD_FEES_FETCHED:
      return action.reservedAdFees
    default:
      return state
  }
}

const totalBalance = (state = null, action) => {
  switch (action.type) {
    case TOTAL_BALANCE_FETCHED:
      return action.totalBalance
    default:
      return state
  }
}

export default combineReducers({
  saleBalances,
  totalBalance,
  reservedAdFees
})
